import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-magic-numbers */
import React, { useEffect, useState } from 'react';
import { FramedMedia } from '@hub/framed-media';
import { useIsAboveFold } from '../is-above-fold-provider';
import { useBestImage } from './helpers/find-best-image';
import { useImageSizes } from './helpers/use-image-sizes';
import { useSrcSet } from './helpers/use-src-set';
import { DeviceType, videoSrcFromSGPageTemplateImage } from './helpers/cloudinary-video-url';
import { jsx as _jsx } from "react/jsx-runtime";
export * from './constants';
export function CloudinaryImage(_ref) {
  var _preferredImage$alt;
  let {
    ratio,
    imageSetOrImage,
    preferredImageType,
    resizeMode,
    imageFormat,
    maxWidth,
    minWidth,
    sx,
    as,
    imageRef,
    sizes,
    loadingMode,
    onClick
  } = _ref;
  const {
    0: imageRatio,
    1: setImageRatio
  } = useState(ratio || 0);
  const preferredImage = useBestImage(imageSetOrImage, preferredImageType);
  useEffect(() => {
    async function getImageOriginalRatio() {
      try {
        const image = new Image();
        image.src = preferredImage.url;
        await image.decode();
        if (image.naturalHeight) {
          setImageRatio(image.naturalWidth / image.naturalHeight);
        }
      } catch {
        setImageRatio(1);
      }
    }
    if (!ratio) {
      getImageOriginalRatio();
    }
  }, [ratio, preferredImage]);
  const imageSrcSet = useSrcSet(preferredImage, imageRatio, resizeMode, imageFormat);
  const imageSizes = useImageSizes(sizes);
  const isAboveFold = useIsAboveFold();
  const defaultLoadingMode = isAboveFold ? 'eager' : 'lazy';
  const EPSILON = 0.00001;
  const isWide = imageRatio === '21/9' || typeof imageRatio === 'number' && Math.abs(imageRatio - 21 / 9) < EPSILON;
  const videoSrc = videoSrcFromSGPageTemplateImage(preferredImage, isWide ? DeviceType.wide : DeviceType.square);
  return imageRatio ? /*#__PURE__*/_jsx(FramedMedia, {
    ref: imageRef,
    as: as,
    ratio: imageRatio,
    minWidth: minWidth,
    maxWidth: maxWidth,
    onClick: onClick,
    sx: _objectSpread({
      position: 'relative',
      isolation: 'isolate'
    }, sx),
    description: (_preferredImage$alt = preferredImage.alt) !== null && _preferredImage$alt !== void 0 ? _preferredImage$alt : undefined,
    sizes: imageSizes,
    loading: loadingMode !== null && loadingMode !== void 0 ? loadingMode : defaultLoadingMode,
    imageSrcSet: imageSrcSet,
    videoSrc: videoSrc,
    "data-id": "cloudinary-image_index_CloudinaryImage_FramedMedia"
  }) : null;
}